import type { ReactNode } from "react";

export const SimulatorResultsBlock = (props: { children: ReactNode }) => {
  return (
    <section className="text-primary border-success-medium flex w-full flex-col gap-2.5 rounded-b-lg border-2 p-6 text-sm shadow-inner md:w-1/2 md:rounded-r-lg md:rounded-bl-none">
      {props.children}
    </section>
  );
};
